import { FormikContextType } from 'formik/dist/types'
import { TFunction } from 'i18next'
import set from 'lodash/set'

import { ApiError } from '../state/api'

type UseSetFormErrorsParams = {
  setErrors: FormikContextType<any>['setErrors']
  setStatus: FormikContextType<any>['setStatus']
  t: TFunction
}

export default function setFormErrors({ setErrors, setStatus, t }: UseSetFormErrorsParams, err: any) {
  if (err instanceof ApiError) {
    if (err.fields) {
      const errors: any = {}
      for (const [rawKey, rawMessages] of Object.entries(err.fields)) {
        const key = rawKey
          .split('.')
          .map((s) => s.replaceAll(/_[a-z]/g, (r) => r[1].toUpperCase()))
          .join('.')
        const message = (rawMessages[0] || 'invalid').replaceAll('.', '-')
        set(errors, key, t([`errors.fields.${key}.${message}`, `errors.fields.default.${message}`]))
      }
      setErrors(errors)
    } else {
      const text = t(`errors.${err.message.replaceAll('.', '-')}`)
      setStatus(text === `errors.${err.message.replaceAll('.', '-')}` ? err.message : text)
    }
  } else {
    setStatus(err)
  }
}
